import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { FileUploadModule } from 'ng2-file-upload';
import { SidenavService } from './services/sidenav.service';
import { LoaderDialogComponent } from './components/loader-dialog/loader-dialog.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CheckValuePipe } from './pipes/check-value.pipe';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { SecurePipe } from './pipes/secure.pipe';
import { CheckLanguagePipe } from './pipes/check-language.pipe';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [
    LoaderDialogComponent,
    CheckValuePipe,
    SecurePipe,
    FileUploadComponent,
    NavBarComponent,
    CheckLanguagePipe,
    ConfirmDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FileUploadModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    TranslocoModule,
    LoaderDialogComponent,
    FileUploadComponent,
    CheckValuePipe,
    NavBarComponent,
    SecurePipe,
    CheckLanguagePipe
  ],
  providers: [SidenavService]
})
export class SharedModule { }
